module.exports = __webpack_public_path__ + "media/images/img_rounge_1-a681769af3e400115d483511f5f7419e.jpg";